import { env } from "@/lib/env"
import { mtLocation } from "@/lib/mt-location"

// Pass host from middleware where window is unavailable.
export function getRegionUrl(
  region: "us" | "eu",
  path = "/dashboard",
  host?: string
): string {
  const hostname = host === undefined ? mtLocation.hostname : host.split(":")[0]
  if (hostname === "localhost" || hostname.endsWith(".localhost")) {
    const port = region === "eu" ? 3011 : 3001
    return `http://localhost:${port}${path}`
  }
  return region === "eu"
    ? `https://mindtrip-eu.ai${path}`
    : `https://mindtrip.ai${path}`
}

const dataRegion = () => env("MT_DATA_REGION") ?? "us"

export const isEuRegion = () => dataRegion() === "eu"
export const isUsRegion = () => dataRegion() === "us"
export const bookingsEnabled = () => !isEuRegion()
export const receiptsEnabled = () => !isEuRegion()

// Distinguishes the admin host (mindtrip-eu.ai) from subdomains like
// embedded.mindtrip-eu.ai. Pass host from middleware when we have a request.
export const isEuAdminSite = (host?: string) => {
  if (!isEuRegion()) return false
  const adminHost = new URL(env("NEXT_PUBLIC_DOMAIN_URL") ?? "http://localhost")
    .host
  if (host !== undefined) return host === adminHost
  if (typeof window === "undefined") return true
  return mtLocation.host === adminHost
}
